import type { OrganizationalLicense } from '../types/subscription';

export default function getOrganizationalLicensePayer(
  organizationalLicense: OrganizationalLicense
): 'school' | 'district' {
  return organizationalLicense.districtId ? 'district' : 'school';
}
